<script setup>
const { locale, locales, setLocale } = useI18n();

const localeData = computed(() =>
  locales.value.find((localeData) => localeData.code === locale.value),
);

defineProps({
  triggerEvent: {
    type: String,
    default: undefined,
  },
});

function onLocalChange(locale, close) {
  if (!locale || !close || !setLocale) return;

  setLocale(locale);
  close();
}
</script>

<template>
  <UiDropdown
    class="bundles-lang-select"
    position="bottom"
    :trigger-event="triggerEvent"
    use-v-if
  >
    <template #trigger>
      <div class="bundles-lang-select__trigger">
        <slot />

        <CCountryFlag
          :key="localeData.region"
          class="bundles-lang-select__flag bundles-lang-select__flag--trigger"
          :code="localeData.region"
          :with-border="false"
        />
      </div>
    </template>

    <template #content="{ close }">
      <ul class="bundles-lang-select__list">
        <li
          v-for="localeItem in locales"
          :key="localeItem.code"
          class="bundles-lang-select__item"
          :class="{
            'bundles-lang-select__item--selected': locale === localeItem.code,
          }"
          @click="onLocalChange(localeItem.code, close)"
        >
          <CCountryFlag
            class="bundles-lang-select__flag"
            :code="localeItem.region"
          />

          <span class="bundles-lang-select__font">
            {{ localeItem.localizedName }}
          </span>
        </li>
      </ul>
    </template>
  </UiDropdown>
</template>
